module.exports = ".modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1 !important;\n  background-color: #000; }\n\n.quebrarLinha {\n  width: 20px !important; }\n\n.black-transparent {\n  background-color: #0000004d; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/adm.component.scss
// module id = ./src/app/login/adm.component.scss
// module chunks = main